import { render, staticRenderFns } from "./CVTypeVolunteer.vue?vue&type=template&id=6004b824"
import script from "./CVTypeVolunteer.vue?vue&type=script&lang=js"
export * from "./CVTypeVolunteer.vue?vue&type=script&lang=js"
import style0 from "./CVTypeVolunteer.vue?vue&type=style&index=0&id=6004b824&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports